/* eslint-disable class-methods-use-this */
import Cookies from 'js-cookie';

class CookiesDataService {
  getDataList(key = '') {
    const dataListFromCookies = Cookies.get(key);

    if (dataListFromCookies) {
      return JSON.parse(dataListFromCookies);
    }

    return [];
  }

  getIsIncludesData(key, value) {
    const dataListFromCookies = this.getDataList(key);

    return !!dataListFromCookies.find((id) => id === value);
  }

  setActualData(key, value) {
    const dataFromCookies = this.getDataList(key);

    if (dataFromCookies.length === 0) {
      const valueList = [value];
      Cookies.set(key, JSON.stringify(valueList));

      return valueList;
    }

    const updatedData =
      dataFromCookies.includes(value) ?
        dataFromCookies.filter((id) => id !== value)
      : [...dataFromCookies, value];

    Cookies.set(key, JSON.stringify(updatedData));

    return updatedData;
  }

  clearActualData(key) {
    if (Cookies.get(key)) {
      Cookies.remove(key);
    }
  }
}

export const cookiesDataService = new CookiesDataService();
